import { Button, Flex, Input, InputGroup, InputLeftAddon, Text } from '@chakra-ui/react'
import { useRef } from 'react'

export function PedidoAprovado() {
  const numNotaRef = useRef('')

  async function onSubmit(e) {
    e.preventDefault()
    const numNota = numNotaRef.current.value

    if (!numNota) {
      alert('Campo vazio!')
      return
    }

    window.open(`${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-pdf-vendas-interno/${numNota}`)
  }

  return (
    <Flex flexDirection="column" gap={2} as="form" onSubmit={onSubmit}>
      <Text fontSize="2xl" fontWeight="bold" bg="#1db85d" color="white" py={2} textAlign="center">
        Pedido Aprovado
      </Text>
      <InputGroup fontFamily="Akrobat" size="sm">
        <InputLeftAddon bgColor="#1db85d" color="white" children="Nº ÚNICO:" height="100%" />
        <Input
          onFocus
          focusBorderColor="#1db85d"
          bgColor="white"
          autoFocus
          placeholder="Digite o número..."
          type="number"
          size="lg"
          ref={numNotaRef}
        />
      </InputGroup>
      <Flex gap={2} flexDir="column">
        <Button bgColor="gray.200" _hover={{ filter: 'brightness(0.9)' }} color="#1db85d" size="lg" type="submit">
          {' '}
          Filtrar{' '}
        </Button>
      </Flex>
    </Flex>
  )
}
